import React from 'react';
import { Skeleton } from '../../../ui/Skeleton';
import { NavMenu } from './NavMenu';

export const WorkspaceMenuSkeleton = React.memo(() => {

    return <NavMenu>
        <NavMenu.Item>
            <NavMenu.ItemIcon>
                <Skeleton />
            </NavMenu.ItemIcon>
            <NavMenu.ItemLabel>
                <Skeleton width="12" />
            </NavMenu.ItemLabel>
        </NavMenu.Item>
        <NavMenu.Item>
            <NavMenu.ItemIcon>
                <Skeleton />
            </NavMenu.ItemIcon>
            <NavMenu.ItemLabel>
                <Skeleton width="10" />
            </NavMenu.ItemLabel>
        </NavMenu.Item>
        <NavMenu.Item>
            <NavMenu.ItemIcon>
                <Skeleton />
            </NavMenu.ItemIcon>
            <NavMenu.ItemLabel>
                <Skeleton width="9" />
            </NavMenu.ItemLabel>
        </NavMenu.Item>
    </NavMenu>;
});

